import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';
import { compose, mapProps } from 'recompose';
import ShareProduct from './ShareProduct';

const enhance = compose(
    withDeviceInfo,
    mapProps(({ userDevice, ...rest }) => ({
        ...rest,
        isMobile: userDevice === 'mobile',
    })),
);

export default enhance(ShareProduct);
